/** Partner portal access from POST /admin/partner-login `communityCreated`. */
export const isPartnerCommunityCreated = (partner) => Boolean(partner?.communityCreated);
